import 'css-chunksrc/dev-tools/LoyaltyCustomerOnboardTool.module.scss';export default {
  "form": "LoyaltyCustomerOnboardTool_form",
  "birthMonthDay": "LoyaltyCustomerOnboardTool_birthMonthDay",
  "select": "LoyaltyCustomerOnboardTool_select"
};